import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';

import { OfflineRfsOrder } from '../../../models/OfflineRfs';
import DriverETAMap from '../../pickupOrder/DriverETA/DriverETAMap';
import { TextField, Button } from '@material-ui/core';
import style from './driverETA.module.css';
import moment from 'moment';
import { CalendarToday, QueryBuilder } from "@material-ui/icons";


interface DriverETASelect {
  classes: any;
  order: OfflineRfsOrder;
  destination: { lat: number, lng: number } | null;
  userLocation: { lat: number, lng: number } | null;
  handleUpdate: (type: string) => void;
  eta: string;
  arrivalTime: Date;
  changeEta: (event: any) => void;
};

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '100%',
      height: '36px',
      margin: '0 0 0 2%',
      textTransform: 'none',
      borderRadius: '10px'
    },
  });

const driverETASelect = (props: DriverETASelect) => {

  const { classes, order, destination, userLocation } = props;

  return (
    <>
    <div className={ style.opsInfo }>
      <div>
        <p>Operator:</p>
        <p>Driver:</p>
        <p>License Plate:</p>
        { order.sealed && order.seal_number && <p>Seal Number:</p> }
        <p>Departure:</p>
        <p>ETA:</p>
        <p>Deliver To:</p>
      </div>
      <div className={ style.darker }>
        <p>{ order.delivery_company_name }</p>
        <p>{ order.driver_name }</p>
        <p>{ order.driver_vehichle_registration }</p>
        { order.sealed && order.seal_number && <p>{ order.seal_number }</p> }
        <p>{ moment(order.arrival_date).format('DDMMMYY').toUpperCase() +' '+ moment(order.arrival_time).format('HH:mm') }</p>
        <p>{ moment(props.arrivalTime).format('DD MMM YYYY HH:mm').toUpperCase() }</p>
        <p>
          { order.droppointname }<br />
          { order.info && <span>{order.info.addr1}</span> }<br />
          { order.info && order.info.addr2 && <> <span>{order.info.addr2}</span> <br /></> }
          { order.info && ( order.info.city+' '+order.info.state+' '+order.info.zip ) }
        </p>
      </div>
    </div>
    <div className={ style.mapContainer }>
      { userLocation !== null?<DriverETAMap destination={ destination || { lat: 0, lng: 0 } } userLocation={ userLocation } />:null }
    </div>
    <div>
      <div className={ style.inputWrapper }>
        <div>
        <label>Estimated Arrival</label>
        <TextField
          id="outlined-helperText"
          label=""
          value={ moment(props.arrivalTime).format('DD MMM YYYY HH:mm').toUpperCase() }
          onChange={ (event) => props.changeEta(event) }
          variant="outlined"
        />
        
        </div>
        <Button  
          color="primary" 
          variant="contained"
          onClick={ (events) => props.handleUpdate('auto') }
          className={ classes.button } 
        >
          Set ETA(Auto)
        </Button>
      </div>
      <div className={ style.divider }></div>
      <div className={ style.inputWrapperManual }>
        <div className={ style.manualPickers }>
        <KeyboardDatePicker
          className={ classes.datePicker }
          value={ moment(props.arrivalTime).format('DD MMM YYYY HH:MM').toUpperCase() }
          format={ 'DD MMM YYYY' }
          onChange={ (event) => props.changeEta(event) }
          InputProps={{ className: classes.blue } }
        />
        <KeyboardTimePicker
          format={ 'HH:mm' }
          value={ props.arrivalTime }
          onChange={ (event) => props.changeEta(event)}
          keyboardIcon={ <QueryBuilder color='primary' /> }
        />
        
        </div>
        <div className={ style.buttonDiv }>
          <Button  
            color="primary" 
            variant="contained"
            onClick={ (events) => props.handleUpdate('manual') }
            className={  style.manualButton } 
          >
            Set ETA(Manual)
          </Button>
        </div>
        
      </div>
    
    </div>
    </>
  );
}

export default withStyles(styles)(driverETASelect);